export const SHIP_SECTIONS = [
    {
        id: "bridge",
        name: "Мостик",
        shortName: "Мостик",
        description: "Командование, навигация и удалённое управление кораблём.",
        x: 330,
        y: 34,
        width: 240,
        height: 108,
        accent: "#72e6ff"
    },
    {
        id: "medbay",
        name: "Медицинский отсек",
        shortName: "Медотсек",
        description: "Лечение экипажа и контроль состояния команды.",
        x: 54,
        y: 204,
        width: 214,
        height: 124,
        accent: "#77f2b4"
    },
    {
        id: "life-support",
        name: "Жизнеобеспечение",
        shortName: "Жизнеобеспечение",
        description: "Кислород, фильтрация воздуха и управление вентиляцией.",
        x: 343,
        y: 204,
        width: 214,
        height: 124,
        accent: "#a5f36b"
    },
    {
        id: "reactor",
        name: "Реакторный отсек",
        shortName: "Реактор",
        description: "Источник энергии и наиболее опасное оборудование корабля.",
        x: 632,
        y: 204,
        width: 214,
        height: 124,
        accent: "#d9a7ff"
    },
    {
        id: "airlock",
        name: "Шлюз",
        shortName: "Шлюз",
        description: "Выход в космос и изоляция разгерметизированных зон.",
        x: 54,
        y: 414,
        width: 214,
        height: 112,
        accent: "#8da8ff"
    },
    {
        id: "engineering",
        name: "Инженерный отсек",
        shortName: "Инженерный",
        description: "Распределение энергии, ремонт кабелей и пожаротушение.",
        x: 343,
        y: 414,
        width: 214,
        height: 112,
        accent: "#ffbd69"
    },
    {
        id: "cargo",
        name: "Грузовой отсек",
        shortName: "Грузовой",
        description: "Запасы, инструменты и крепление опасных грузов.",
        x: 632,
        y: 414,
        width: 214,
        height: 112,
        accent: "#ff8e8e"
    }
];
export const SHIP_CONNECTIONS = [
    { from: "bridge", to: "medbay", travelSeconds: 4 },
    { from: "bridge", to: "life-support", travelSeconds: 3 },
    { from: "bridge", to: "reactor", travelSeconds: 4 },
    { from: "medbay", to: "airlock", travelSeconds: 4 },
    { from: "life-support", to: "engineering", travelSeconds: 4 },
    { from: "reactor", to: "engineering", travelSeconds: 3 },
    { from: "reactor", to: "cargo", travelSeconds: 4 },
    { from: "airlock", to: "engineering", travelSeconds: 5 },
    { from: "engineering", to: "cargo", travelSeconds: 3 }
];
export const PLAYER_COLORS = ["#52d8ff", "#ffcc66", "#ff769f", "#8ef08a"];
export function getSectionDefinition(sectionId) {
    return SHIP_SECTIONS.find((section) => section.id === sectionId);
}
export function getTravelSeconds(from, to) {
    return SHIP_CONNECTIONS.find((connection) => (connection.from === from && connection.to === to) ||
        (connection.from === to && connection.to === from))?.travelSeconds;
}
//# sourceMappingURL=ship.js.map